export default __webpack_public_path__ + "static/googleSheetIcon-0055fe78a8f0d3ef975da61b79ff9f0c.svg";